import styled, { css } from 'styled-components'
import { BG_LIGHT_BLUE, white, PRIMARY_LIGHT } from '../../shared/styles/colors'
import { fontSize } from '../../shared/styles/mixins'

export const Wrapper = styled.footer`
  display: flex;
  flex-direction: column;
  padding: 0;
  background: ${PRIMARY_LIGHT};
  color: ${white};
  border-top: 1px solid #C6D2EC;
  margin-bottom: 160px;
  z-index: 2;
  @media(max-width: 600px) {
    margin-bottom: 96px;
  }
`

export const Logo = styled.div`
  width: 132px;
  height: 92px;
  margin: 0 auto;
  margin-bottom: 42px;
`

export const TopWrapper = styled.section`
  width: 100%;
  background-color: white;
  padding-top: 48px;
`

export const Links = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  list-style: none;
`

export const LinksItem = styled.li`
  position: relative;
  padding: 0 5px;
  margin-left: 14px;
  font-size: 0.875rem;

  &:not(:last-child):after {
    content: '●';
    position: absolute;
    top: 0;
    right: -11.5px;
  }

  & > a:hover {
    text-decoration: underline;
  }
`

export const ANS = styled.div`
  margin: 0 auto 16px;
`

export const AddressPart = styled.p`
  ${fontSize(10)};
  display: block;
  font-weight: 300;
  text-align: center;

  ${({ hasSpacing }) =>
    hasSpacing &&
    css`
      margin-bottom: 16px;
    `}
`

export const FooterInfos = styled.section`
  color: #707070;
  margin-bottom: 16px;
`

export const SocialLinksContainer = styled.nav`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 48px;
  color: #121a3d;
`

export const BottomWrapper = styled.section`
  width: 100%;
  background-color: white;
`

export const ContactsArea = styled.section`
  width: 488px;
  padding: 68px 0 76px;
  margin: auto;
  display: flex;

  @media (max-width: 600px) {
    width: 100%;
    justify-content: center;
    flex-direction: column;
    padding: 48px 20px 32px;
  }
`
